

















import CrearButton from '@/reusable/Grid/CrearButton.vue';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';

@Component({
  components: {
    FormFieldsContainer,
    CrearButton,
  },
})
export default class HeaderInforme extends Vue {
  @Prop({ required: true }) dataInforme: any;
  row: any = null;

  handleClick() {
    console.log('dataInfomre');
  }
}
